import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import {AppMessage} from "./ui/AppMessage";
import {logger} from "./utils/Log";
import {MultiDropdown} from "./components/MultiDropdown";

type PaymentAction = "chargeback" | "earlyFraud" | "falsePositive" | "paid";

interface PaymentActionData {
  action: PaymentAction;
  token: string; // payment token
  // more params...
}

export class Merchant extends AbstractPage {
    protected multiDropdown: MultiDropdown;

    constructor(app: JqueryApp) {
        super(app);
        this.multiDropdown = new MultiDropdown(app);

        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.initPage();
            this.addEventListeners();
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected initPage() {
        this.togglePayoutMethodInputs(this.app.$("#payoutMethodVal").val() as string);
    }

    protected addEventListeners() {
      const config = this.app.getConfig();

        if (this.app.$("#refundAmountGateway").length !== 0) {
            this.onRefundAmountChange(this.app.$(this.app.$("#refundAmount")).val() as number);
            this.app.$("#refundAmount").on("change", (event) => {
                this.onRefundAmountChange(this.app.$(event.target).val() as number);
            });
            this.app.$("#refundAmount").on("keyup", (event) => {
                this.onRefundAmountChange(this.app.$(event.target).val() as number);
            });
        }

        this.app.$("#chargeback-tx").on("click", (event) => {
          event.preventDefault();
          if (this.app.getWebHelpers().window.confirm(this.app.getTr().get("chargebackConfirm"))) {
            const token = this.app.$("#chargeback-tx").attr("data-token");
            let data = {
              action: "chargeback" as PaymentAction,
              token: token,
            }
            this.sendPaymentAction(data);
          }
        });

      this.app.$("#early-fraud-tx").on("click", (event) => {
        event.preventDefault();
        if (this.app.getWebHelpers().window.confirm(this.app.getTr().get("earlyFraudConfirm"))) {
          const token = this.app.$("#early-fraud-tx").attr("data-token");
          let data = {
            action: "earlyFraud" as PaymentAction,
            token: token,
          }
          this.sendPaymentAction(data);
        }
      });

      this.app.$("#early-fraud-false-positive").on("click", (event) => {
        event.preventDefault();
        if (this.app.getWebHelpers().window.confirm(this.app.getTr().get("earlyFraudFalseConfirm"))) {
          const token = this.app.$("#early-fraud-false-positive").attr("data-token");
          let data = {
            action: "falsePositive" as PaymentAction,
            token: token,
          }
          this.sendPaymentAction(data);
        }
      });

      this.app.$("#early-fraud-refund").on("click", (event) => {
        event.preventDefault();
        if (this.app.getWebHelpers().window.confirm(this.app.getTr().get("earlyFraudRefundConfirm"))) {
          const token = this.app.$("#early-fraud-refund").attr("data-token");
          let data = {
            action: "earlyFraudAndRefund" as PaymentAction,
            token: token,
          }
          this.sendPaymentAction(data);
        }
      });

      this.app.$("#mark-paid").on("click", (event) => {
        event.preventDefault();
        if (this.app.getWebHelpers().window.confirm(this.app.getTr().get("markPaidConfirm"))) {
          const token = this.app.$("#mark-paid").attr("data-token");
          let data = {
            action: "paid" as PaymentAction,
            token: token,
          }
          this.sendPaymentAction(data);
        }
      });

        this.app.$("#payoutMethods a").on("click", (event) => {
            const method = this.app.$(event.target).attr("data-val");
            this.togglePayoutMethodInputs(method);
            //const tr = this.app.getTr();
            this.app.$("#payoutMethodVal").attr("value", method);
            this.app.$("#payoutMethod").text(this.app.$(event.target).text());
        });
        this.app.$("#requestPayout").on("click", (event) => {
            if (!this.app.getWebHelpers().window.confirm(this.app.getTr().get("requestPayoutAsk"))) {
                event.preventDefault();
            }
        });

        this.app.$("#paymentGateways a").on("click", (event) => {
            const method = this.app.$(event.target).attr("data-val");
            this.app.$("#gatewayVal").attr("value", method);
            this.app.$("#gateway").text(this.app.$(event.target).text());
        });

        // this.app.$("#gateway-form").on("submit", (event) => {
        //     event.preventDefault();
        // });
    }

    protected onRefundAmountChange(amount: number) {
        let gatewayAmount = amount * this.app.getConfig().exchangeRate;
        this.app.$("#refundAmountGateway").val(gatewayAmount.toFixed(2));
    }

    protected togglePayoutMethodInputs(method: string) {
        switch (method) {
            //case "paypal":
            case "usdt_eth":
                this.app.$(".method-swift").fadeOut("slow");
                this.app.$(".method-usdteth").fadeIn("slow");
                break;
            case "swift":
                this.app.$(".method-usdteth").fadeOut("slow");
                this.app.$(".method-swift").fadeIn("slow");
                break;
            default:
                logger.error("Unknown payout method: " + method);
        }
    }

    protected sendPaymentAction(data: PaymentActionData): void {
      const config = this.app.getConfig();
      //delete data.token; // not needed
      const urlStr = config.apiBase + config.pathPaymentAction + "/" + data.token; // part of merchant route instead of API base
      this.webHelpers.getApi(urlStr, data, (data) => {
        if (data && data.errorMsg) {
          const msg = new AppMessage(data.errorMsg,"danger");
          msg.display();
        }
        if (!data || data.error) {
          console.error("Error during payment action", data);
          return;
        }
        if (typeof data.successMsg === "string" && data.successMsg.length > 0) {
          const msg = new AppMessage(data.successMsg,"success"); // TODO "undefined" ?
          msg.display();
        }
      });
    }
}
